'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dtm = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actions = require('../actions');

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dtm = exports.dtm = function dtm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions.PAGE_DATA_RECEIVED:
      var page = (0, _lodash2.default)(action, 'payload.page') || {};
      var cardData = (0, _lodash2.default)(action, 'payload.cards[0]') || {};
      var pageDtm = page.dtm || {};
      var language = pageDtm.language || 'EN';
      var businessUnit = pageDtm.businessUnit || 'AMEX';
      var primaryCategory = pageDtm.primaryCategory || 'Acq';
      var subCategory1 = pageDtm.subCategory1 || '';
      var subCategory2 = pageDtm.subCategory2 || 'CardDetail';
      var subCategory3 = pageDtm.subCategory3 || '';
      var pageName = pageDtm.pageName || cardData.dtmProductName || '';
      var country = pageDtm.country || 'AU';
      var pmc = pageDtm.pmc || '';
      var linkNavBase = (country + '-' + language + '-' + primaryCategory + '-gcp-' + subCategory1).toLowerCase();

      var pageDtmInfo = {
        language: language,
        businessUnit: businessUnit,
        primaryCategory: primaryCategory,
        subCategory1: subCategory1,
        subCategory2: subCategory2,
        subCategory3: subCategory3,
        pageName: pageName,
        country: country,
        pmc: pmc,
        linkNavBase: linkNavBase
      };
      return (0, _extends3.default)({}, state, pageDtmInfo);
    default:
      return state;
  }
};